import Big from 'big.js'
import { INPUT_EMISSION_AMOUNT_DECIMAL_PRECISION } from 'utils/constants/enums'

const bigConfig = {
  DP: 20,
  RM: 1,
  NE: -20,
}

Big.NE = bigConfig.NE
Big.RM = bigConfig.RM
Big.DP = bigConfig.DP

export const createBigNumber = (value: string | number) => new Big(value)
export function bigAdd(value1: string | number, value2: string | number): Big {
  const num1 = new Big(value1)
  const num2 = new Big(value2)
  return num1.plus(num2)
}

export function bigSubtract(
  value1: string | number,
  value2: string | number,
): Big {
  const num1 = new Big(value1)
  const num2 = new Big(value2)
  return num1.minus(num2)
}

export function bigMultiply(
  value1: string | number | Big.Big,
  value2: string | number | Big.Big,
): Big {
  const num1 = new Big(value1)
  const num2 = new Big(value2)
  return num1.times(num2)
}

export function bigDivide(
  value1: string | number | Big.Big,
  value2: string | number | Big.Big,
): Big {
  const num1 = new Big(value1)
  const num2 = new Big(value2)
  return num1.div(num2)
}

/**
 * Rounds a given value to a specified number of decimal places and
 * returns it as a string without trailing zeros.
 *
 * @param input - The value to round, which can be a Big instance, number, or string.
 * @param decimalPlaces - The number of decimal places to round to.
 * @returns The rounded value as a string without trailing zeros.
 */
export function bigRoundAndToString(
  input: Big | number | string,
  decimalPlaces: number = INPUT_EMISSION_AMOUNT_DECIMAL_PRECISION.MAX_DECIMAL_DIGITS,
): string {
  // Convert input to a Big instance if it's not already
  const bigValue = input instanceof Big ? input : new Big(input)

  // Round the value to the specified decimal places
  const roundedValue = bigValue.round(decimalPlaces)

  // Return the result as a string without trailing zeros
  return roundedValue.toString()
}

export { Big }
